import {
    GET_BOM_LIST_PROGRESS, GET_BOM_LIST_SUCCESS, GET_BOM_LIST_FAILURE,
    ADD_BOM_PROGRESS, ADD_BOM_SUCCESS, ADD_BOM_FAILURE,
    EDIT_DELETE_BOM_PROGRESS, EDIT_DELETE_BOM_SUCCESS, EDIT_DELETE_BOM_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    bom: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const bom_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_BOM_LIST_SUCCESS:
            return { ...state, bom: action.bom, loading: false };
        case GET_BOM_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_BOM_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_BOM_PROGRESS:
            return { ...state, loading: true };
        case ADD_BOM_SUCCESS:
            return { ...state, bom: [...state.bom, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_BOM_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_BOM_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_BOM_SUCCESS:
            return {
                ...state,
                bom: state.bom.map((bom) =>
                    bom.id === action.payload.id ? action.payload : bom
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_BOM_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default bom_reducer;